import { HashLoader } from "react-spinners";

const Spinner = () => {
    return (
        <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
            < HashLoader color="#e48181" />
        </div>
    )
}
export default Spinner;


